import { $t } from '@/utils/languageAuto';
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';

var UnbindAccountModal = function (_super) {
  __extends(UnbindAccountModal, _super);

  function UnbindAccountModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.saveLoading = false;
    return _this;
  }

  UnbindAccountModal.prototype.handleOk = function () {
    var _this = this;

    this.$confirm({
      title: this.t('解绑'),
      content: this.t('确认解绑该店铺的当前绑定主体？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, void 0, function () {
          var code;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                this.saveLoading = true;
                _a.label = 1;

              case 1:
                _a.trys.push([1,, 3, 4]);

                return [4, this.$api.shopManage.unbindAccount({
                  id: this.record.id
                })];

              case 2:
                code = _a.sent().code;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.visible = false;
                  this.$emit('success');
                }

                return [3, 4];

              case 3:
                this.saveLoading = false;
                return [7];

              case 4:
                return [2];
            }
          });
        });
      }
    });
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], UnbindAccountModal.prototype, "record", void 0);

  UnbindAccountModal = __decorate([Component], UnbindAccountModal);
  return UnbindAccountModal;
}(Vue);

export default UnbindAccountModal;